import {
  backdropClasses,
  dialogClasses,
  dialogContentClasses,
  paperClasses,
} from '@mui/material';
import {
  DialogActions as MuiDialogActions,
  DialogTitle,
} from '@mui/material';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${backdropClasses.root}`]: {
    backgroundColor: 'rgba(14, 44, 51, 0.90)',
  },
  [`& .${dialogClasses.container}`]: {
    alignItems: 'flex-end',
  },
  [`& .${dialogContentClasses.root}`]: {
    minWidth: 'initial',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 74,
  },
  [`& .${paperClasses.root}`]: {
    'boxShadow': 'none',
    'backgroundColor': theme.palette.background.default,
    'padding': 0,
    'minHeight': 720,
    'minWidth': 1075,
    'maxHeight': 'calc(100% - 74px)',
    'maxWidth': 'calc(100% - 80px)',
    'borderRadius': '8px 8px 0px 0px',
    [theme.breakpoints.down(1075)]: {
      minWidth: 'unset',
    },
    [theme.breakpoints.down(1200)]: {
      maxHeight: 'calc(100% - 36px)',
      maxWidth: 'calc(100% - 48px)',
    },
    '@media (max-height: 800px)': {
      minHeight: 'unset',
    },
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: 0,
  fontSize: 22,
  fontWeight: 600,
  lineHeight: '16px',
  color: theme.palette.primary.main,
  fontFamily: theme.typography.body1.fontFamily,
  marginBottom: 10,
}));

export const DialogSmallText = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  lineHeight: '15px',
  fontWeight: 400,
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.body1.fontFamily,
}));

export const StyledDialogSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.body1.fontFamily,
  maxWidth: 700,
  textAlign: 'center',
}));

export const CloseIconButton = styled(IconButton)(({ theme }) => ({
  'position': 'fixed',
  'padding': 0,
  'right': 66,
  'top': 26,
  '&:hover': {
    backgroundColor: 'transparent',
  },
  [theme.breakpoints.down(1200)]: {
    'right': 12,
    'top': 12,
    '& svg': {
      width: 16,
      height: 16,
    },
  },
}));

export const TitleWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  marginTop: 40,
});

export const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: 74,
}));
